import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../contexts/auth";
import { collection, getDocs, updateDoc, doc, arrayUnion, getDoc } from "@firebase/firestore";
import { db } from '../../services/firebaseConnection';
import Header from "../../components/Header";
import Title from "../../components/Title";
import { FiHome, FiStar, FiSend, FiSearch } from "react-icons/fi";
import Comment from "./comment";
import './dashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Dashboard() {
    const { user } = useContext(AuthContext);
    const [posts, setPosts] = useState([]);
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [newComments, setNewComments] = useState({});
    const [filterPlace, setFilterPlace] = useState("");
    const [filterUser, setFilterUser] = useState("");
    const [xpAtual, setXpAtual] = useState(0);
    const [nivel, setNivel] = useState(1);
    const { getGame, atualizarXP } = useContext(AuthContext);

    const loadPosts = useCallback(async () => {
        const postsCollection = collection(db, "posts");
        const usersCollection = collection(db, "users"); 
        const postsSnapshot = await getDocs(postsCollection);
        const userSnapshot = await getDocs(usersCollection);
        
       
        const userMap = {};
        userSnapshot.docs.forEach(doc => {
            const data = doc.data();
            userMap[doc.id] = { username: data.username, avatarUrl: data.avatarUrl };
        });
        
        const postsList = postsSnapshot.docs.map(doc => {
            const data = doc.data();
            const user = userMap[data.userId] || { username: '', avatarUrl: '' }; 
            return {
                id: doc.id,
                ...data,
                images: data.images || [],
                ratings: data.ratings || [],
                comments: data.comments || [], 
                showComments: false,
                userId: data.userId || '',
                avatarUrl: user.avatarUrl || '',
                username: user.username ? user.username.toUpperCase() : "Usuário Desconhecido",
                created: data.created ? data.created.toDate() : null
            };
        });

        postsList.sort((a, b) => {
            if (!a.created) return 1;
            if (!b.created) return -1;
            return b.created - a.created;
        });

        const gameData = await getGame(user.user_id);
        const xpAtualizado = gameData?.xp ?? 0;

        setPosts(postsList);
        setFilteredPosts(postsList); 
        setXpAtual(xpAtualizado);
        setNivel(gameData?.nivel ?? 1);
    }, [user.user_id, getGame]);

    useEffect(() => {
        loadPosts();
    }, [loadPosts]);

    const handleSearchPlace = () => {
        const filtered = posts.filter(post => post.endereco.toLowerCase().includes(filterPlace.toLowerCase()));
        setFilteredPosts(filtered);
    };

    const handleSearchUser = () => {
        const filtered = posts.filter(post => post.username.toLowerCase().includes(filterUser.toLowerCase()));
        setFilteredPosts(filtered);
    };

    async function handleComment(postId, comment) {
        if (!user) {
            console.error("Usuário não autenticado.");
            return;
        }
    
        if (!comment.trim()) {
            console.error("O comentário não pode estar vazio.");
            return;
        }
    
        const postRef = doc(db, "posts", postId);
        const newComment = {
            id: Date.now().toString(),
            userId: user.user_id,
            username: user.username,
            avatarUrl: user.avatarUrl,
            comment: comment.trim(),
        };
    
        console.log(newComment); 
    
        await updateDoc(postRef, {
            comments: arrayUnion(newComment) 
        });
    
        loadPosts(); 
    }

    async function handleRating(postId, rating) {
        if (!user || !user.user_id) {
            console.error("Usuário não autenticado ou não identificado.");
            return;
        }
    
        const postRef = doc(db, "posts", postId);
        try {
            const postSnapshot = await getDoc(postRef);
            if (!postSnapshot.exists()) {
                console.error("Post não encontrado.");
                return;
            }
            
            let postData = postSnapshot.data();
    
            
            if (!postData.ratings || !Array.isArray(postData.ratings)) {
                postData = {
                    ...postData,
                    ratings: []
                };
            }
    
            const existingRatingIndex = postData.ratings.findIndex(r => r.userId === user.user_id);
    
            if (existingRatingIndex === -1) {
                
                await updateDoc(postRef, {
                    ratings: arrayUnion({ userId: user.user_id, rating: rating })
                });
            } else {
               
                const updatedRatings = postData.ratings.map((r, index) => 
                    index === existingRatingIndex ? { userId: user.user_id, rating: rating } : r
                );
    
                await updateDoc(postRef, {
                    ratings: updatedRatings
                });
            }
    
           
            await loadPosts();
    
        } catch (error) {
            console.error("Erro ao processar a avaliação:", error);
        }
    }

    const xpParaProximoNivel = (nivel) => {
        return 150 * nivel;
      };
    
    const adicionarXP = () => {
        const xpGanho = 5;
        const novoXP = xpAtual + xpGanho;
        const xpNecessario = xpParaProximoNivel(nivel);
        let novoNivel = nivel;
        setXpAtual(novoXP);
    
        if (novoXP >= xpNecessario) {
            novoNivel = nivel + 1;
            setNivel(novoNivel);
        }
        
        setXpAtual(novoXP);
        atualizarXP(user.user_id, novoXP, novoNivel);
      };
    
    
    const handleStarClick = (postId, index) => {
        handleRating(postId, index + 1);
    };

    const handleSendComment = (postId) => {
        if (!newComments[postId]?.trim()) {
            console.error("O comentário não pode estar vazio.");
            return;
        }
        handleComment(postId, newComments[postId]);
        adicionarXP();
        setNewComments(prev => ({ ...prev, [postId]: "" })); 
    };

    const handleCommentChange = (postId, value) => {
        setNewComments(prev => ({ ...prev, [postId]: value })); 
    };
    


    const toggleComments = (postId) => {
        const updatedPosts = posts.map(post => {
            if (post.id === postId) {
                return { ...post, showComments: !post.showComments };
            }
            return post;
        });
        setPosts(updatedPosts);
        setFilteredPosts(updatedPosts); 
    };

    const renderComments = (comments) => {
        return comments.map(comment => (
            <Comment key={comment.id} comment={comment} />
        )); 
    };
    
    const getMaxUserRating = (post) => {
        const userRating = post.ratings.find(r => r.userId === user.user_id);
        return userRating ? userRating.rating : 0;
    };

    return (
        <div>
            <Header />
            <div className="dashboard">
                <Title name="Feed">
                    <FiHome size={25} />
                </Title>

                <div className="filters">
                    <div className="filter-container">
                        <input
                            type="text"
                            placeholder="Buscar por lugar"
                            value={filterPlace}
                            onChange={(e) => setFilterPlace(e.target.value)}
                        />
                        <FiSearch size={15} onClick={handleSearchPlace} className="search-icon" />
                    </div>
                </div>

                <div id="posts-container">
                    {filteredPosts.map((post) => (
                        <div key={post.id} id="post">
                            <div className="post-header">
                                {post.avatarUrl ? (
                                    <img src={post.avatarUrl} className="post-avatar" alt="Avatar do usuário" />
                                ) : null}
                                <span className="post-username">{post.username}</span>
                            </div>
                            <h3>{post.titulo}</h3>
                            <p>{post.descricao}</p>
                            <p>Localização: {post.endereco}</p>

                            {post.images.length > 0 ? (
                                post.images.length > 1 ? (
                                    <div id={`carousel-${post.id}`} className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {post.images.map((url, idx) => (
                                                <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                                                    <img src={url} className="d-block w-100" alt={`Imagem ${idx + 1}`} />
                                                </div>
                                            ))}
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${post.id}`} data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Anterior</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${post.id}`} data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Próximo</span>
                                        </button>
                                    </div>
                                ) : (
                                    <img src={post.images[0]} alt={`Imagem`} className="d-block w-100" />
                                )
                            ) : (
                                <p>Não há imagem.</p>
                            )}
                            <div className="ratings">
                                {[...Array(5)].map((_, index) => (
                                    <FiStar
                                        key={index}
                                        color={index < getMaxUserRating(post) ? "gold" : "gray"}
                                        onClick={() => handleStarClick(post.id, index)}
                                    />
                                ))}
                            </div>
                            <div className="comments">
                                {post.comments.length > 0 && (
                                    <button
                                        className="toggle-comments"
                                        onClick={() => toggleComments(post.id)}
                                    >
                                        {post.showComments ? 'Esconder Comentários' : 'Mostrar Comentários'}
                                    </button>
                                )}
                                {post.showComments && renderComments(post.comments)}
                                <div className="comment-input">
                                    <textarea
                                        placeholder="Digite um comentário"
                                        style={{ resize: 'none'}}
                                        value={newComments[post.id] || ""} 
                                        onChange={(e) => handleCommentChange(post.id, e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleSendComment(post.id);
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <FiSend onClick={() => handleSendComment(post.id)} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
